'use client';

import { useEffect } from 'react';

export function DebugInfo() {
  useEffect(() => {
    // Log all stylesheets
    const styleSheets = Array.from(document.styleSheets);
    console.log('Loaded stylesheets:', styleSheets.map(s => s.href));
    
    // Log computed font styles
    const body = document.body;
    const computedStyle = window.getComputedStyle(body);
    console.log('Body font-family:', computedStyle.fontFamily);
    console.log('CSS variables:', {
      '--font-inter': computedStyle.getPropertyValue('--font-inter'),
      '--font-playfair': computedStyle.getPropertyValue('--font-playfair'),
    });
    
    // Log first h1 font
    const h1 = document.querySelector('h1');
    if (h1) {
      const h1Style = window.getComputedStyle(h1);
      console.log('H1 font-family:', h1Style.fontFamily);
    }
    
    // Log image loading issues
    const images = document.querySelectorAll('img');
    images.forEach((img, index) => {
      if (!img.complete || img.naturalWidth === 0) {
        console.error(`Image ${index} failed to load:`, {
          src: img.src,
          alt: img.alt,
          complete: img.complete,
          naturalWidth: img.naturalWidth
        });
      }
    });
    
    // Check Next.js config
    console.log('Next.js public runtime config:', 
      (window as any).__NEXT_DATA__?.runtimeConfig);
  }, []);
  
  return null;
}